<template lang="pug">
.v-status.status
	template(v-if="status")
		.status__list
			.status__item(v-for="(item, index) in status" :key="index")
				.status-label(:style="{'background': item.background, 'color': item.color}")
					v-svg-icon.status-label-icon(v-if="item.icon" :icon="item.icon")
					| {{item.text}}
</template>

<script>

export default {
	props: {
		status: {
			type: Array,
			default: null
		}
	}
};
</script>
